import React, { useState, Fragment, useEffect } from 'react';
import 'rc-datepicker/lib/style.css';
import './style.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import localization from 'assets/localization/localization';
import { handleValidateObj } from 'constants/objValues/objvalues';
import DatePicker from 'components/sales/datePicker/datePicker';
import { handleFormatDate } from 'constants/dateFormat/dateFormat';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const CategoryDetails = ({
  isSupply = false,
  isApartments = false,
  isB2b = false,
  handleValue,
  supplyNameFun = null,
  splNameData = null,
  rwaTenureFun = null,
  rwaTenureData = null,
  supDropDownData,
  corDropDownData,
  appartmentDropDown,
  prefilledData = null,
  isDefalut,
  documentUploadUrl
}) => {
  const demandInputs = {
    leadCat: { id: null, value: '' },
    leadCatId: '',
    supplyName: { id: null, value: '' },
    slotsNo: '',
    reservedSlots: '',
    fcfsSlots: '',
  };
  const suplyInputs = {
    carSlots: '',
    bikeSlots: '',
    otherSlots: '',
    // occupancyCar: { id: null, value: '' },
    // occupancyBike: { id: null, value: '' },
    entryGates: '',
    exitGates: '',
    parkingFloors: '',
    parkingRevenue: '',
    securityAgency: '',
    parkingAgency: '',
    // photos: ''
  };

  const appartmentInputs = {
    // date: new Date(),
    // gatesNo: '',
    carsNo: '',
    // rwaTenure: { id: null, value: '' },
    flatNo: '',
    societyType: { id: null, value: '' },
    // gateType: { id: null, value: '' },
    managedBy: { id: null, value: '' },
    maintainanceCharges: ''
  };

  const aptOptInputs = {
    // carsNo: '',
    // HelpStaffNo: '',
    avgChFlat: '',
    requirDesc: '',
    vms: { id: null, value: '' },
    existingGates: { id: null, value: '' },
    occupancy: { id: null, value: '' },
    disputeLevel: { id: null, value: '' },
    societyUpkeeping: { id: null, value: '' },
    amenities: { id: null, value: '' },
    securityAgency: ''
  };

  const [categoryDemandData, setCategoryDemandData] = useState(demandInputs);
  const [categorySupplyData, setCategorySupplyData] = useState(suplyInputs);
  const [categoryArtData, setCategoryArtData] = useState(appartmentInputs);
  const [aptOpt, setAptOpt] = useState(aptOptInputs);
  const [isDemand, setIsDemand] = useState(null);
  const [categories, setCategories] = useState();

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setCategoryDemandData(demandInputs);
      setCategorySupplyData(suplyInputs);
      setCategoryArtData(appartmentInputs);
      setAptOpt(aptOptInputs);
      setIsDemand(null);
      setCategories();
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  useEffect(() => {
    if (
      prefilledData?.lead_data !== undefined &&
      prefilledData?.lead_data !== null
    ) {
      const {
        lead_category,
        lead_category_id,
        fcfs,
        no_of_gates,
        reserved,
        no_of_slots,
        // no_of_cars,
        no_of_flats,
        // no_of_staff,
        rwa_details,
        supply_id,
        supply_name,
        requirements_description,
        society_type_id,
        society_type,
        maintainance_charges,
        security_agency,
        gate_type_id,
        gate_type,
        vms_type_id,
        vms_type,
        existing_setup_id,
        existing_setup,
        occupancy_id,
        occupancy,
        dispute_level_id,
        dispute_level,
        society_upkeeping_id,
        society_upkeeping,
        amenities_id,
        amenities,
        managed_by_id,
        managed_by,
        car_slots,
        bike_slots,
        other_slots,
        entry_gates,
        exit_gates,
        parking_floors,
        parking_rev,
        occup_car,
        occup_bike,
        sec_agency,
        park_agency

      } = prefilledData?.lead_data;
      setIsDemand(lead_category_id);
      setCategoryDemandData({
        ...categoryDemandData,
        leadCat: { id: lead_category_id, value: lead_category },
        slotsNo: `${no_of_slots}`,
        fcfsSlots: `${fcfs}`,
        reservedSlots: `${reserved}`,
        supplyName: { id: supply_id, value: supply_name },
      });
      setCategorySupplyData({
        ...categorySupplyData,
        gatesNo: `${no_of_gates}`,
        slotsNo: `${no_of_slots}`,
        carSlots: `${car_slots}`,
        bikeSlots: `${bike_slots}`,
        otherSlots: `${other_slots}`,
        occupancyCar: {id: occup_car, value: occup_car},
        occupancyBike: {id: occup_bike, value: occup_bike},
        entryGates: `${entry_gates}`,
        exitGates: `${exit_gates}`,
        parkingFloors: `${parking_floors}`,
        parkingRevenue: `${parking_rev}`,
        securityAgency: `${sec_agency}`,
        parkingAgency: `${park_agency}`,
        // photos: `${}`
      });
      setCategoryArtData({
        ...categoryArtData,
        // gatesNo: `${no_of_gates}`,
        /* rwaTenure: {
          id: `${rwa_details?.tenure}`,
          value: `${rwa_details?.tenure}`,
        }, */
        // carsNo: `${no_of_cars}`,
        flatNo: `${no_of_flats}`,
        // date: `${rwa_details?.date}`,
        maintainanceCharges: `${maintainance_charges}`,
        societyType: {
          id: `${society_type_id}`,
          value: `${society_type}`
        },
        // gateType: {
        //   id: `${gate_type_id}`,
        //   value: `${gate_type}`
        // },
        
        managedBy: {
          id: `${managed_by_id}`,
          value: `${managed_by}`
        },
      });
      setAptOpt({
        ...aptOpt,
        // carsNo: `${no_of_cars}`,
        // HelpStaffNo: `${no_of_staff}`,
        avgChFlat: `${rwa_details?.maintenance_charge}`,
        requirDesc: requirements_description,
        securityAgency: `${security_agency}`,
        vms: {
          id: `${vms_type_id}`,
          value: `${vms_type}`
        },
        existingGates: {
          id: `${existing_setup_id}`,
          value: `${existing_setup}`
        },
        occupancy: {
          id: `${occupancy_id}`,
          value: `${occupancy}`
        },
        disputeLevel: {
          id: `${dispute_level_id}`,
          value: `${dispute_level}`
        },
        societyUpkeeping: {
          id: `${society_upkeeping_id}`,
          value: `${society_upkeeping}`
        },
        amenities: {
          id: `${amenities_id}`,
          value: `${amenities}`
        },
      });
    }
  }, [prefilledData]);

  useEffect(() => {
    if (supDropDownData) {
      const { categories } = supDropDownData;
      setCategories(categories);
    }
  }, [supDropDownData]);

  useEffect(() => {
    if (corDropDownData) {
      const { categories } = corDropDownData;
      setCategories(categories);
    }
  }, [corDropDownData]);

  useEffect(() => {
    if (appartmentDropDown) {
      const { categories } = appartmentDropDown;
      setCategories(categories);
      // console.log(rwaTenureData);
    }
  }, [appartmentDropDown]);

  useEffect(() => {
    if (supplyNameFun !== null) (async () => await supplyNameFun())();
    if (rwaTenureFun !== null) (async () => await rwaTenureFun())();
  }, [supplyNameFun, rwaTenureFun]);

  const handleDemand = ({ id, value }) => {
    setIsDemand(id);
    setCategoryDemandData({
      ...categoryDemandData,
      leadCat: { id: id, value: value },
      leadCatId: id,
      slotsNo: '',
    });
    setCategorySupplyData({ ...categorySupplyData, gatesNo: '' });
    // setCategoryArtData({ ...categoryArtData, gatesNo: '' });
  };

  const handleDateChange = (jsdate) =>
    setCategoryArtData({ ...categoryArtData, date: jsdate });

  // useEffect(() => {
  //   const formatDate = handleFormatDate();
  //   setCategoryArtData({ ...categoryArtData, date: formatDate });
  // }, []);

  const handleCategoryData = () => {
    if (isSupply === true) {
      handleValue(categorySupplyData);
    }
    if (isApartments === true) {
      const apartmentsObj = {
        leadCatId: categoryDemandData.leadCat.id,
        // gatesNo: categoryArtData.gatesNo,
        flatNo: categoryArtData.flatNo,
        date: categoryArtData.date,
        // rwaTenure: categoryArtData.rwaTenure.id,
        societyType: categoryArtData.societyType.id,
        // gateType: categoryArtData.gateType.id,
        // vms: categoryArtData.vms.id,
        // existingGates: categoryArtData.existingGates.id,
        // occupancy: categoryArtData.occupancy.id,
        // disputeLevel: categoryArtData.disputeLevel.id,
        // societyUpkeeping: categoryArtData.societyUpkeeping.id,
        // amenities: categoryArtData.amenities.id,
        managedBy: categoryArtData.managedBy.id,
        maintainanceCharges: categoryArtData.maintainanceCharges,
      };
      const isNotEmpty = handleValidateObj(apartmentsObj);
      if (isNotEmpty !== false) {
        handleValue({
          ...apartmentsObj,
          vms: aptOpt.vms.id,
          existingGates: aptOpt.existingGates.id,
          occupancy: aptOpt.occupancy.id,
          disputeLevel: aptOpt.disputeLevel.id,
          societyUpkeeping: aptOpt.societyUpkeeping.id,
          amenities: aptOpt.amenities.id,
          securityAgency: aptOpt.securityAgency,
          // slotsNo: categoryDemandData.slotsNo,
          // carsNo: aptOpt.carsNo,
          // HelpStaffNo: aptOpt.HelpStaffNo,
          // avgChFlat: aptOpt.avgChFlat,
        });
      }
    }
    /* if (isB2b === false) {
      if (isDemand === '') handleValue(null);
      if (isSupply === false) {
        if (isApartments === false) {
          if (isDemand === 2) {
            if (categoryDemandData.slotsNo !== '') {
              const demandobj = { ...categoryDemandData };
              demandobj.leadCat = categoryDemandData.leadCat.value;
              handleValue({
                ...demandobj,
                leadCatId: categoryDemandData.leadCat.id,
                supplyName: categoryDemandData.supplyName.id,
                reservedSlots: categoryDemandData.reservedSlots,
                fcfsSlots: categoryDemandData.fcfsSlots,
              });
            } else {
              handleValue(null);
            }
          } else if (isDemand === 3 || isDemand === 1) {
            if (isApartments === false) {
              if (isDemand === 1) {
                let objGate = categorySupplyData.gatesNo;
                const isNotEmpty = handleValidateObj({ objGate });
                if (isNotEmpty !== false)
                  handleValue({
                    ...categorySupplyData,
                    leadCat: categoryDemandData.leadCat.value,
                    leadCatId: categoryDemandData.leadCat.id,
                    slotsNo: categoryDemandData.slotsNo,
                  });
              } else {
                if (isDemand === 3 && isApartments === false) {
                  const isObj = categoryDemandData.slotsNo;
                  const isEmpty = handleValidateObj({ isObj });
                  if (isEmpty !== false) {
                    handleValue({
                      leadcat: categoryDemandData.leadCat.value,
                      leadCatId: categoryDemandData.leadCat.id,
                      gatesNo: categorySupplyData.gatesNo,
                      slotsNo: categoryDemandData.slotsNo,
                    });
                  }
                }
              }
            }
          }
        }
      }
    } */
  };

  useEffect(() => {
    handleCategoryData();
  }, [
    // categoryDemandData,
    // isDemand,
    categorySupplyData,
    categoryArtData,
    aptOpt,
  ]);

  const handleSupplyName = () => {
    if (isDemand === 2) {
      return (
        <Fragment>
         
          <DropDownInput
            data={splNameData}
            label={localization.supplyNamePost}
            getIdValue={(val) =>
              setCategoryDemandData({
                ...categoryDemandData,
                supplyName: { id: val.id, value: val.value },
              })
            }
            value={categoryDemandData.supplyName.value}
          />
          <ConstantInput
            label={localization.noOfSlots}
            regex={Regex.numericNotZero.test(categoryDemandData.slotsNo)}
            errorMsg={
              categoryDemandData.slotsNo === ''
                ? localization.requiredSlot
                : localization.enterValidData
            }
            type="number"
            handleChange={(val) =>
              setCategoryDemandData({ ...categoryDemandData, slotsNo: val })
            }
            value={`${categoryDemandData?.slotsNo}`}
          />
          <ConstantInput
            label={localization.reservedSlots}
            regex={Regex.number.test(categoryDemandData.reservedSlots)}
            // errorMsg={localization.requiredReserve}
            errorMsg={
              categoryDemandData.reservedSlots
                ? localization.numericError
                : localization.requiredReserve
            }
            type="text"
            maxLength={3}
            handleChange={(val) =>
              setCategoryDemandData({
                ...categoryDemandData,
                reservedSlots: val,
              })
            }
            value={categoryDemandData.reservedSlots}
          />
          <ConstantInput
            label={localization.FCFSSlots}
            regex={Regex.number.test(categoryDemandData.fcfsSlots)}
            errorMsg={
              categoryDemandData.fcfsSlots
                ? localization.numericError
                : localization.requiredFCFSslot
            }
            type="text"
            maxLength={3}
            handleChange={(val) =>
              setCategoryDemandData({ ...categoryDemandData, fcfsSlots: val })
            }
            value={categoryDemandData.fcfsSlots}
          />
          <ConstantInput
              label={localization.noOfgates}
              regex={Regex.numericNotZero.test(
                isApartments
                  ? categoryArtData.gatesNo
                  : categorySupplyData.gatesNo
              )}
              errorMsg={
                isApartments
                  ? categoryArtData.gatesNo === ''
                    ? localization.requiredGate
                    : localization.validDataForNoOfGates
                  : categorySupplyData.gatesNo === ''
                  ? localization.requiredGate
                  : localization.validDataForNoOfGates
              }
              type="numeric"
              handleChange={(val) => {
                isApartments
                  ? setCategoryArtData({ ...categoryArtData, gatesNo: val })
                  : setCategorySupplyData({
                      ...categorySupplyData,
                      gatesNo: val,
                    });
              }}
              maxLength={4}
              required
              value={categoryArtData.gatesNo}
              isStarRequired={true}
            />
        </Fragment>
      );
    }
  };

  const handleofGates = () => {
    if (isDemand === 3 || isDemand === 1) {
      return (
        <Fragment>
          {isDemand === 3 ? (
            <ConstantInput
              label={localization.noOfSlots}
              regex={
                isApartments
                  ? null
                  : Regex.numericNotZero.test(categoryDemandData.slotsNo)
              }
              errorMsg={
                categoryDemandData.slotsNo
                  ? localization.numericError
                  : localization.requiredSlot
              }
              type="text"
              maxLength={3}
              handleChange={(val) =>
                setCategoryDemandData({ ...categoryDemandData, slotsNo: val })
              }
              required={isApartments ? false : true}
              value={categorySupplyData.slotsNo}
              isStarRequired={isApartments ? false : true}
            />
          ) : null}
          
        </Fragment>
      );
    }
  };
  return (
    <Fragment>
    
      <FormSection title={localization.categoryDetails}>
      <div className="form-colo">
        
        {isSupply ? null : (
          <DropDownInput
            label={localization.LeadCategory}
            data={categories}
            getIdValue={(val) => handleDemand(val)}
            errorMsg={localization.requiredLeadCateg}
            required
            isStarRequired={true}
            isBottom
            value={categoryDemandData.leadCat.value}
          />
        )}  
        {isSupply ? (
          <Fragment>
            <ConstantInput
              label={localization.carSlot}
              regex={Regex.number.test(categorySupplyData.carSlots)}
              /* errorMsg={
                categorySupplyData.carSlots === ''
                  ? localization.isRequired
                  : localization.enterValidData
              } */
              type="number"
              handleChange={(val) => {
                setCategorySupplyData({
                  ...categorySupplyData,
                  carSlots: val.replace(/^0+/, ''),
                });
              }}
              value={categorySupplyData.carSlots}
            />
            <ConstantInput
              label={localization.bikeSlot}
              regex={Regex.number.test(categorySupplyData.bikeSlots)}
              /* errorMsg={
                categorySupplyData.bikeSlots === ''
                  ? localization.isRequired
                  : localization.enterValidData
              } */
              type="number"
              handleChange={(val) => {
                setCategorySupplyData({
                  ...categorySupplyData,
                  bikeSlots: val,
                });
              }}
              value={categorySupplyData.bikeSlots}
            />
            <ConstantInput
              label={localization.otherSlots}
              regex={Regex.number.test(categorySupplyData.otherSlots)}
              /* errorMsg={
                categorySupplyData.otherSlots === ''
                  ? localization.isRequired
                  : localization.enterValidData
              } */
              type="number"
              handleChange={(val) => {
                setCategorySupplyData({
                  ...categorySupplyData,
                  otherSlots: val.replace(/^0+/, ''),
                });
              }}
              value={categorySupplyData.otherSlots}
              
            />
            <DropDownInput
              label={localization.occupancyCars}
              data={[
                {
                  id: "<50%",
                  name: "<50%",
                },
                {
                  id: "50%-60%",
                  name: "50%-60%",
                },
                {
                  id: "60%-80%",
                  name: "60%-80%",
                },
                {
                  id: "80%-90%",
                  name: "80%-90%",
                },
                {
                  id: "90%-100%",
                  name: "90%-100%",
                },
                {
                  id: "100%-120%",
                  name: "100%-120%",
                },
                {
                  id: "120%-150%",
                  name: "120%-150%",
                },
                {
                  id: "150%-200%",
                  name: "150%-200%",
                },
                {
                  id: "200%-250%",
                  name: "200%-250%",
                },
                {
                  id: "250%-300%",
                  name: "250%-300%",
                },
              ]}
              getIdValue={(val) =>
                setCategorySupplyData({
                  ...categorySupplyData,
                  occupancyCar: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={categorySupplyData?.occupancyCar?.value}
            />
            <DropDownInput
              label={localization.occpancyBike}
              data={[
                {
                  id: "<50%",
                  name: "<50%",
                },
                {
                  id: "50%-100%",
                  name: "50%-100%",
                }
              ]}
              getIdValue={(val) =>
                setCategorySupplyData({
                  ...categorySupplyData,
                  occupancyBike: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={categorySupplyData?.occupancyBike?.value}
            />
            <ConstantInput
              label={localization.entryGates}
              regex={Regex.number.test(categorySupplyData.entryGates)}
              /* errorMsg={
                categorySupplyData.entryGates === ''
                  ? localization.isRequired
                  : localization.enterValidData
              } */
              type="number"
              handleChange={(val) => {
                setCategorySupplyData({
                  ...categorySupplyData,
                  entryGates: val,
                });
              }}
              value={categorySupplyData.entryGates}
              // isNotZero
            />
            <ConstantInput
              label={localization.exitGates}
              regex={Regex.number.test(categorySupplyData.exitGates)}
              type="number"
              handleChange={(val) => {
                setCategorySupplyData({
                  ...categorySupplyData,
                  // exitGates: val.replace(/^0+/, ''),
                  exitGates: val,
                });
              }}
              value={categorySupplyData.exitGates}
            />
            <ConstantInput
              label={localization.parkingFloors}
              regex={Regex.number.test(categorySupplyData.parkingFloors)}
              type="number"
              handleChange={(val) => {
                setCategorySupplyData({
                  ...categorySupplyData,
                  parkingFloors: val,
                });
              }}
              value={categorySupplyData.parkingFloors}
            />
            <ConstantInput
              label={localization.parkingRevenue}
              type="text"
              className="indianrupee"
              isPrefix
              prefixText={'₹'}
              regex={Regex.twodecimal.test(categorySupplyData.parkingRevenue)}
              handleChange={(val) =>
                setCategorySupplyData({ ...categorySupplyData, parkingRevenue: val })
              }
              value={categorySupplyData.parkingRevenue}
            />
            <ConstantInput
              label={localization.securityAgency}
              regex={Regex.text.test(categorySupplyData.securityAgency)}
              type="text"
              handleChange={(val) => setCategorySupplyData({ ...categorySupplyData, securityAgency: val })}
              value={categorySupplyData.securityAgency}
            />
            <ConstantInput
              label={localization.parkingAgency}
              regex={Regex.text.test(categorySupplyData.parkingAgency)}
              type="text"
              handleChange={(val) => setCategorySupplyData({ ...categorySupplyData, parkingAgency: val })}
              value={categorySupplyData.parkingAgency}
            />
            {/* {(prefilledData?.lead_data !== undefined &&
              prefilledData?.lead_data !== null
            ) ? null : 
            <FileUpload
              id="rel_photos"
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) => setCategorySupplyData({
                ...categorySupplyData,
                photos: val.toString(),
              })}
              multiple={true}
            >
              <span className="btn btn-transparent">
                {localization.addPhotos}
              </span>
            </FileUpload>
            
            } */}
          </Fragment>
        ) : (
          <Fragment>
            {isApartments === true ? null : handleSupplyName()}{' '}
            {/* {handleofGates()} */}
          </Fragment>
        )}
        {isApartments ? (
          <Fragment>
            {/* <ConstantInput
              label={localization.noOfCars}
              regex={Regex.number.test(aptOpt.carsNo)}
              errorMsg={
                aptOpt.carsNo === ''
                  ? localization.isRequired
                  : localization.enterValidData
              }
              type="number"
              handleChange={(val) => {
                setAptOpt({
                  ...aptOpt,
                  carsNo: val.replace(/^0+/, ''),
                });
              }}
              value={aptOpt.carsNo}
              isNotZero
            /> */}
            <DropDownInput
              label={localization.societyType}
              data={rwaTenureData.societyType}
              errorMsg={localization.requiredSocietyType}
              required
              getIdValue={(val) =>
                setCategoryArtData({
                  ...categoryArtData,
                  societyType: { id: val.id, value: val.value },
                })
              }
              isStarRequired={true}
              isBottom
              value={categoryArtData.societyType.value}
            />
            
            <ConstantInput
              label={localization.noOfFlats}
              regex={Regex.number.test(categoryArtData.flatNo)}
              errorMsg={
                categoryArtData.flatNo === ''
                  ? localization.isRequired
                  : localization.enterValidData
              }
              type="number"
              required
              isStarRequired={true}
              handleChange={(val) =>
                setCategoryArtData({
                  ...categoryArtData,
                  flatNo: val.replace(/^0+/, ''),
                })
              }
              value={categoryArtData.flatNo}
              isNotZero
            />
           
            <DropDownInput
              label={localization.vms}
              data={rwaTenureData.vmsType}
              getIdValue={(val) =>
                setAptOpt({
                  ...aptOpt,
                  vms: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={aptOpt.vms.value}
              isStarRequired={true}
              required
            />
            <DropDownInput
              label={localization.existingsetup}
              data={rwaTenureData.existingGates}
              getIdValue={(val) =>
                setAptOpt({
                  ...aptOpt,
                  existingGates: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={aptOpt.existingGates.value}
            />
            <ConstantInput
              label={localization.maintainanceCharges}
              regex={Regex.number.test(categoryArtData.maintainanceCharges)}
              errorMsg={
                categoryArtData.maintainanceCharges === ''
                  ? localization.isRequired
                  : localization.enterValidData
              }
              type="number"
              required
              isStarRequired={true}
              handleChange={(val) =>
                setCategoryArtData({
                  ...categoryArtData,
                  maintainanceCharges: val.replace(/^0+/, ''),
                })
              }
              value={categoryArtData.maintainanceCharges}
              isNotZero
            />
            <DropDownInput
              label={localization.occupancy}
              data={rwaTenureData.occupancy}
              getIdValue={(val) =>
                setAptOpt({
                  ...aptOpt,
                  occupancy: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={aptOpt.occupancy.value}
            />
            <ConstantInput
              label={localization.securityAgency}
              regex={Regex.text.test(aptOpt.securityAgency)}
              type="text"
              handleChange={(val) => setAptOpt({ ...aptOpt, securityAgency: val })}
              // required={isSupply ? false : true}
              // isStarRequired={isSupply ? false : true}
              value={aptOpt.securityAgency}
            />
            <DropDownInput
              label={localization.disputeLevel}
              data={rwaTenureData.disputeLevel}
              getIdValue={(val) =>
                setAptOpt({
                  ...aptOpt,
                  disputeLevel: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={aptOpt.disputeLevel.value}
            />
            <DropDownInput
              label={localization.societyUpkeeping}
              data={rwaTenureData.societyUpkeeping}
              getIdValue={(val) =>
                setAptOpt({
                  ...aptOpt,
                  societyUpkeeping: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={aptOpt.societyUpkeeping.value}
            />
            <DropDownInput
              label={localization.amenities}
              data={rwaTenureData.amenities}
              getIdValue={(val) =>
                setAptOpt({
                  ...aptOpt,
                  amenities: { id: val.id, value: val.value },
                })
              }
              isBottom
              value={aptOpt.amenities.value}
            />
            <DropDownInput
              label={localization.managedBy}
              data={rwaTenureData.managedBy}
              errorMsg={localization.requiredManagedBy}
              required
              getIdValue={(val) =>
                setCategoryArtData({
                  ...categoryArtData,
                  managedBy: { id: val.id, value: val.value },
                })
              }
              isStarRequired={true}
              isBottom
              value={categoryArtData.managedBy.value}
            />
            {/* <ConstantInput
              label={localization.noOfHelpingStaff}
              regex={Regex.number.test(aptOpt.HelpStaffNo)}
              errorMsg={
                aptOpt.HelpStaffNo === ''
                  ? localization.isRequired
                  : localization.enterValidData
              }
              type="number"
              handleChange={(val) =>
                setAptOpt({ ...aptOpt, HelpStaffNo: val.replace(/^0+/, '') })
              }
              value={aptOpt.HelpStaffNo}
              isNotZero
            /> */}

            {/* <DatePicker
              handleChange={(val) => handleDateChange(val)}
              label={localization.RWADate}
              value={categoryArtData.date}
            />
            <DropDownInput
              label={localization.RWATenure}
              errorMsg={localization.isRequired}
              data={rwaTenureData.societyType}
              getIdValue={(val) =>
                setCategoryArtData({
                  ...categoryArtData,
                  rwaTenure: { id: val.id, value: val.value },
                })
              }
              isBottom
              isStarRequired={true}
              value={categoryArtData.rwaTenure.value}
            /> */}
            {/* <ConstantInput
              label={localization.AverageMaintenance}
              type="number"
              regex={Regex.toFixed.test(aptOpt.avgChFlatr)}
              handleChange={(val) => setAptOpt({ ...aptOpt, avgChFlat: val })}
              value={aptOpt.avgChFlat}
            /> */}
          </Fragment>
        ) : null}
        </div>
      </FormSection>
      
    </Fragment>
  );
};

export default CategoryDetails;
